import React from "react";
import CircularProgress from '@material-ui/core/CircularProgress'
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { } from "pages/redux/actions";
import axios from 'axios';
import { connect } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { Button, Card, CardHeader, CardFooter, CardBody, FormGroup, Form, Input, Container, Row, Col, } from "reactstrap";
import UserHeader from "components/Headers/UserHeader.js";


const Profile = (props) => {
    const location = useLocation();

    const hiddenFileInput = React.useRef(null);
    const history = useHistory();
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    // const [id, setid] = React.useState();
    const [afile, setafile] = React.useState();
    const [change, setchange] = React.useState({ user: props.username });
    const [filename, setfilename] = React.useState('Choose a file');
    const [editcontent, seteditcontent] = React.useState('Add');
    const [dcontent, setdcontent] = React.useState(false);
    const fetchData = React.useCallback(() => {
        // console.log('fetching')
    }, [])
    React.useEffect(() => {
        fetchData()
        document.title = "Add Poster - Depact"
    }, [fetchData])

    // console.log(props.token)
    if (location) {
        if (location.state != null) {
            // console.log(location.state.id)
            // console.log(location.state.otype)
            if (location.state.token) {
                if (location.state.token === 1) {
                    // console.log(location.state.id)
                    // console.log(location.state.message);
                    setSendingdata(location.state.message)
                    settt(location.state.type)
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }
        else {
            history.push({
                pathname: 'home',
                state: {
                    "token": 1,
                    "message": "Something went wrong",
                    "type": "error",
                }
            })
        }
    }

    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const handleUpload = () => {
        // console.log('entered')
        hiddenFileInput.current.click()
    };

    const handleChangeU = (event) => {
        setchange({ ...change, [event.target.name]: event.target.files[0] })
        // console.log(event.target.files)
        setafile(URL.createObjectURL(event.target.files[0]))
        setfilename(event.target.files[0].name)
        // console.log(change)
    };

    const handleChangeEdit = () => {
        if (editcontent === 'Add') {
            seteditcontent(<CircularProgress size="20px" className={"textb-" + props.theme} />)
            // setdcontent(true)
            // console.log(change)
            let formdata = new FormData();
            // console.log(formdata)
            if (change.poster === undefined){
                setSendingdata('Please add poster')
                settt('error')
                setOpen(true)
                return 0;
            }
            else {
                formdata.append('file', change.poster, filename)
            }
            // console.log(formdata)
            for (var pair of formdata.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }
            // console.log(formdata)
            axios.post(process.env.REACT_APP_DOMAIN + '/addposter/event=' + location.state.id, formdata, { 'Content-type': 'multipart/form-data', 'Authorization': 'Token ' + props.token })
                .then((response) => {
                    // console.log(response.data)
                    history.push({
                        pathname: '/super-admin/home',
                        state: {
                            "token": 1,
                            "message": 'Successfully Added Poster',
                            'type': 'success'
                        }
                    })
                })
                .catch((error) => {
                    // console.log(error)
                    setOpen(true)
                    setSendingdata('Something went wrong Try Again Later')
                    settt('error')
                })
        }
        else {
            seteditcontent('Add')
            setdcontent(false)
        }
    };

    const handleChangeEdit2 = () => {
        history.push({
            pathname: '/super-admin/home',
            state: {
                "token": 1,
                "message": 'Successfully Added Event',
                'type': 'success'
            }
        })
    };

    return (
        <>
            <UserHeader id={props.username} />
            {/* Page content */}
            <Container className="mt--7" fluid>
                <Row>
                    <Col className="order-xl-1" xl="12">
                        <Card className={"shadow cardbg-" + props.theme}>
                            <CardHeader className={"border-0 cardbg-" + props.theme}>
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className={"mb-0 textb-" + props.theme}>Poster</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="pb-0">
                                <Form>


                                    <h6 className="heading-small text-muted mb-4">Choose a file for Poster</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="4" sm="12" md="12" className="justify-content-center text-center">
                                                <FormGroup>
                                                    <Input className={"text-left form-control-alternative inputbg-" + props.theme} onClick={handleUpload} id="input-cno" value={"Poster : " + filename} placeholder="Event Poster" type="button" />
                                                    <input id="contained-button-file" name="poster" onChange={handleChangeU} type="file" ref={hiddenFileInput} style={{ display: 'none' }} />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="8" xl="8" sm="12" md="12" className="justify-content-center text-center">
                                                <FormGroup>
                                                    {(afile === undefined ?
                                                        <div className={'inputbg-'+props.theme} style={{height: '300px',width: '300px'}}></div>
                                                        :
                                                        <div className={'inputbg-'+props.theme} style={{height: 'auto',width: 'auto'}}><img alt="Poster" style={{maxWidth: '600px'}} src={afile}/></div>
                                                    
                                                    )}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                            </CardBody>
                            <CardFooter className={"cardbg-" + props.theme}>
                                <div className="text-center mt-3">
                                    <Button
                                        color="info"
                                        outline
                                        disabled={dcontent}
                                        onClick={handleChangeEdit}
                                    >
                                        {editcontent}
                                    </Button>
                                    <Button
                                        color="info"
                                        outline
                                        onClick={handleChangeEdit2}
                                    >
                                        Skip
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};


export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Profile);
